import { AuthRequired } from '../types';

/**
 * Row 1880 U2: whether a sign-in card is followed by the "proceed with the available domains" button. A report's own sign-in
 * (an entry naming its report, sourceName) has nothing to proceed with: without the sign-in that report cannot answer, and
 * answering from another report instead is what the card replaces (Marius, 9 October: a prompt to sign in, never the next report).
 */
export function offersProceed(block: AuthRequired): boolean {
    return block.data.some((entry) => !entry.sourceName);
}
